export const SUPERSIM_SPONSORED_NEWS_ID = 276929;
export const SUPERSIM_SPONSORED_NEWS_PIN_START = '2026-06-30T00:00:00-03:00';
export const SUPERSIM_SPONSORED_NEWS_PIN_END = '2026-07-30T23:59:59-03:00';
export const SUPERSIM_SPONSORED_NEWS_LOGO_PATH = '/assets/supersim-botao-sem-fundo-04.svg';
export const SUPERSIM_SPONSORED_NEWS_IMAGE_PATH = '/assets/supersim-emprestimo-pessoal-online-800x400.png';
export const SUPERSIM_SPONSORED_NEWS_IMAGE_ALT = 'Empréstimo pessoal online SuperSim';

const parseDate = (value) => {
    if (value instanceof Date) return value;

    return new Date(value);
};

const getTime = (value) => parseDate(value).getTime();

const getNewsId = (news) => Number(news?.id ?? news?.newsId);

export const isSuperSimSponsoredNews = (news) => getNewsId(news) === SUPERSIM_SPONSORED_NEWS_ID;

export const withSuperSimSponsoredNewsAssets = (news) => {
    if (!isSuperSimSponsoredNews(news)) return news;

    return {
        ...news,
        imageUrl: news.imageUrl || SUPERSIM_SPONSORED_NEWS_IMAGE_PATH,
        imageCaption: news.imageCaption || SUPERSIM_SPONSORED_NEWS_IMAGE_ALT,
    };
};

export const withSuperSimSponsoredNewsAssetsInList = (newsItems = []) => (
    newsItems.map(withSuperSimSponsoredNewsAssets)
);

export const isSuperSimSponsoredNewsPinned = (date = new Date()) => {
    const time = getTime(date);

    return time >= getTime(SUPERSIM_SPONSORED_NEWS_PIN_START) &&
        time <= getTime(SUPERSIM_SPONSORED_NEWS_PIN_END);
};

export const shouldFetchSuperSimSponsoredNews = (newsItems = [], date = new Date()) => (
    isSuperSimSponsoredNewsPinned(date) &&
    !newsItems.some(isSuperSimSponsoredNews)
);

export const placeSuperSimSponsoredNews = (newsItems = [], date = new Date()) => {
    const sponsoredNews = newsItems.find(isSuperSimSponsoredNews);

    if (!sponsoredNews || !isSuperSimSponsoredNewsPinned(date)) {
        return {
            pinnedNews: null,
            newsItems,
        };
    }

    return {
        pinnedNews: sponsoredNews,
        newsItems: newsItems.filter((news) => !isSuperSimSponsoredNews(news)),
    };
};
